

export class Switcher {

  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.max      = parseInt(this.container.dataset.max, 10);
    this.current  = parseInt(this.container.dataset.index, 10);
    this.interval = Math.max(1000, parseInt(this.container.dataset.interval ?? 5000));

    this.container.jsswitch = this;
    this.numberField = this.container.querySelector('.jsswitcher-number');
    this.numberPad = this.numberField?.dataset.pad ?? 1;

    this.container.addEventListener('click', this);

    setTimeout(() => this.start(), Math.random() * 5000)
  }

  start()
  {
    this.handle = setTimeout(() => { this.switch(); }, this.interval);
  }

  stop() {
    if (this.handle) {
      clearInterval(this.handle);
    }
  }

  switch() {
    this.update(this.current + 1);
    this.start();
  }

  update(index) {
    this.current = Math.max(1, index);
    if (this.current > this.max) {
      this.current = 1;
    }
    this.container.dataset.index = this.current;

    if (this.numberField) {
      this.numberField.innerText = this.current.toString().padStart(this.numberPad, '0');
    }
  }

  handleEvent(e) {
    if (e.type !== "click") {
      return;
    }

    switch (e.target.tagName) {
      case "IMG":
        this.next();
        break;
      case "I":
        this.stop();
        this.update(parseInt(e.target.dataset.index, 10));
        this.start();
        break;
      case 'DIV':
        if (e.target.closest('*[data-click="next"]')) {
          this.next();
        }
        break;
    }

  }

  next() {
    this.stop();
    this.update(this.current + 1);
    this.start();
  }
}
